export const STOCK_LIST = [
  {
    id: 1,
    logo: "images/stocks/AAPL.png",
    ticker: "AAPL",
  },
  {
    id: 2,
    logo: "images/stocks/GOOGL.png",
    ticker: "GOOGL",
  },
  {
    id: 3,
    logo: "images/stocks/kakao.png",
    ticker: "카카오",
  },
  {
    id: 4,
    logo: "images/stocks/samsung.png",
    ticker: "삼성전자",
  },
  {
    id: 5,
    logo: "images/stocks/AMZN.png",
    ticker: "AMZN",
  },
  {
    id: 6,
    logo: "images/stocks/MSFT.png",
    ticker: "MSFT",
  },

  {
    id: 7,
    logo: "images/stocks/NVDA.png",
    ticker: "NVDA",
  },
  {
    id: 8,
    logo: "images/stocks/naver.png",
    ticker: "네이버",
  },
];
